// src/pages/FaqPublicResults/components/HelpToolbar.jsx
import React from "react";
import { FaExpandAlt, FaFilter, FaSearch, FaTimes } from "react-icons/fa";
import { HELP_CATEGORIES } from "../faqPublicResultsData";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-indigo-500 dark:focus:ring-indigo-950";

export default function HelpToolbar({
  search,
  setSearch,
  category,
  setCategory,
  onExpandAll,
  onCollapseAll,
  onReset,
}) {
  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/70 dark:text-indigo-300">
            <FaFilter />
            Recherche rapide
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Trouver une réponse
          </h2>
        </div>

        <div className="flex flex-wrap gap-2">
          <ToolbarButton onClick={onExpandAll}>
            <FaExpandAlt />
            Tout ouvrir
          </ToolbarButton>

          <ToolbarButton onClick={onCollapseAll}>
            <FaTimes />
            Tout fermer
          </ToolbarButton>

          <ToolbarButton onClick={onReset} variant="soft">
            Réinitialiser
          </ToolbarButton>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="relative lg:col-span-7">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Rechercher : pesées, QR Code, résultats, tapis, photos..."
            className={`${INPUT} pl-11`}
          />
        </div>

        <select
          value={category}
          onChange={(event) => setCategory(event.target.value)}
          className={`${INPUT} lg:col-span-5`}
        >
          <option value="all">Toutes les catégories</option>
          {HELP_CATEGORIES.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
      </div>
    </section>
  );
}

function ToolbarButton({ children, onClick, variant = "dark" }) {
  const className =
    variant === "soft"
      ? "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
      : "bg-slate-950 text-white hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-100";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-bold transition hover:-translate-y-0.5 ${className}`}
    >
      {children}
    </button>
  );
}